module.exports = __webpack_public_path__ + "static/media/mailImg.a66d8272.svg";